/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// code-reaper-ignore - file is referenced as "browser" entry in package.json
// eslint-disable-next-line jira/jira-ssr/no-server-variable
export const getCurrentRouteSamplingRate = (): number => (__SERVER__ ? 0 : 100);
// eslint-disable-next-line jira/jira-ssr/no-server-variable
export const isAutomaticExposureCollectionEnabled = (): boolean => !__SERVER__;
